import Vue from 'vue'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import "./assets/common.scss";
import 'babel-polyfill'

Vue.config.productionTip = false
Vue.use(iView)
Vue.prototype.$title='派智知产管家'
const online=!(document.domain.includes('beta')|| document.domain=='127.0.0.1')
Vue.prototype.host=online?'http://api.pizhigu.com':'http://tapi.pizhigu.com'
Vue.prototype.online=online
export default Vue


// WEBPACK FOOTER //
// ./src/app.js